export enum EstateTaskUserPriorityKey {
  LOW = 'low',

  NORMAL = 'normal',

  HIGH = 'high',

  URGENT = 'urgent'
}
